const NOTIFICATION_DURATION = 3;

export default NOTIFICATION_DURATION;
